import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useContext } from "react";
import gql from "graphql-tag";
import { useLazyQuery } from "react-apollo";
import { Button } from "../Buttons/Button";
import EditorStemsEmblem from "../EditorStemsEmblem";
import { EditorContext } from "../../editor/context/EditorContext/EditorProvider";

const GET_EDITOR_DEMOS = gql`
  {
    demoTracks {
      id
    }
  }
`;

/**
 * Content rendered inside the editor open-button popover. Caller is
 * responsible for the outer popover chrome (animation, positioning,
 * dark background). This component owns the demo-track lazy query
 * and the subscribe / spawn-demo CTAs.
 */
const EditorPopoverPanel = ({ canAccess }) => {
  const editor = useContext(EditorContext);
  const { push } = useHistory();

  const [getDemoTrackIds, resDemoTracks] = useLazyQuery(GET_EDITOR_DEMOS, {
    onCompleted: () => spawnEditorDemo()
  });

  const spawnEditorDemo = useCallback(() => {
    if (!resDemoTracks.data) return;
    if (resDemoTracks.data.demoTracks.length > 0) {
      const demoTrackId =
        resDemoTracks.data.demoTracks[
          Math.floor(Math.random() * resDemoTracks.data.demoTracks.length)
        ].id;
      editor.requestTrackIdOpen(demoTrackId, true, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resDemoTracks.data]);

  return (
    <div id="editor-popover-container">
      <div id="editor-popover-title">
        {canAccess ? (
          <div>
            Multitrack Editor
            <span className="editor-new-text">NEW</span>
          </div>
        ) : (
          "Subscribe for access to this track"
        )}
      </div>
      <div id="editor-popover-content" className="visible">
        {canAccess ? (
          <div className="stems-emblem">
            Make quick edits to the track from the stem files and
            download your high-quality Custom Mix.
            <EditorStemsEmblem />
          </div>
        ) : (
          <div>
            The Multitrack Editor for this track is only available to
            subscribers and license holders.
            <div className="free-tier-ctas">
              <Button
                className="btn-editor-demo"
                onClick={() => {
                  if (!resDemoTracks.called) getDemoTrackIds();
                  if (resDemoTracks.data) {
                    spawnEditorDemo();
                  }
                }}
              >
                Try out editor
              </Button>
              <Button
                className="btn-subscribe"
                onClick={() => {
                  editor.close();
                  push("/subscription");
                }}
              >
                Subscribe
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditorPopoverPanel;
